<ion-list mode="ios" lines="none" class="ion-no-margin list-content">
  <ng-container *ngIf="MenuHeader | async">
    <ion-button
      size="default"
      mode="ios"
      color="white"
      class="mpe-no-padding"
      [ngClass]="heart ? 'circle-game-last' : 'circle-game'"
    >
    </ion-button>
    <ion-icon
      color="darkblue"
      [src]="'Icons.games-multicolor' | translate"
      class="games-multicolor"
    ></ion-icon>
  </ng-container>

  <ng-container *ngIf="heart">
    <ion-icon
      [src]="'Icons.shadow-game-control' | translate"
      class="img-broken-heart animated fadeIn fast"
    ></ion-icon>
  </ng-container>

  <ion-icon name="triangule-right" color="white" class="mark"></ion-icon>

  <ion-card mode="ios" color="white-grad" class="card-content">
    <ion-item mode="md" lines="none" color="transparent" class="">
      <ion-img
        [src]="'Icons.gepp-games-logo' | translate"
        class="img-logo-games"
        alt="gepp-games-logo"
      ></ion-img>
    </ion-item>

    <ion-item
      mode="md"
      lines="none"
      color="transparent"
      class="ion-text-center item-text"
    >
      <ion-label mode="md" color="darkblue" class="new-games-section-your-app">
        {{ 'Labels.new-games-section-your-app' | translate }}
      </ion-label>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        size="default"
        mode="md"
        color="gradient-blue"
        class="button-enderstood"
        (click)="onClose(true)"
      >
        <ion-label mode="md" color="white" class="mpe-font-weight-600 to-play">
          {{ 'Buttons.to-play' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>

    <ion-item mode="md" lines="none" color="transparent">
      <ion-button
        size="default"
        mode="md"
        fill="clear"
        color="grayDemon"
        class="mpe-button-link-simple button-simple"
        (click)="onClose(false)"
      >
        <ion-label mode="md" color="status-icon-enable" class="later">
          {{ 'Buttons.later' | translate }}
        </ion-label>
      </ion-button>
    </ion-item>
  </ion-card>
</ion-list>
